import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import ReplenishmentMail from "./ReplenishmentMail";
import ReplenishmentUpload from "./ReplenishmentUpload";
import i18n from "../../constants/Strings";
import useReplenishmentMailViewController from "../../viewControllers/ReplenishmentViewControllers/ReplenishmentMailViewController";

const Replenishment = () => {

  const text = {
    replenishment: i18n.t("replenishment.replenishment"),
    uploadTab: i18n.t("replenishment.uploadTab"),
    mailTab: i18n.t("replenishment.mailTab")
  }

  const {fetchData} = useReplenishmentMailViewController()


  return (
    <>

      <div className="container-fluid">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold txt-primary">
            {text.replenishment}
          </h6>
        </div>
        <Tabs
          defaultActiveKey="upload"
          className="mb-3"
          fill
        >
          <Tab eventKey="upload" title={text.uploadTab}>
            <ReplenishmentUpload />
          </Tab>

          <Tab eventKey="mail" title={text.mailTab} >
            <ReplenishmentMail />
          </Tab>
        </Tabs>
      </div>

    </>
  );
};

export default Replenishment;
